import { useAuth0 } from '@/common/auth';

export default {
  install(Vue: any, options: any) {
    Vue.prototype.$auth = useAuth0(options);
  }
};
